'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var language_en_US = require('../../../consts/language_en_US.js');
var index$1 = require('../../../components/SelectList/index.js');
var index = require('../../../components/Language/index.js');
require('../../../components/Spinner/index.js');
require('../../../components/Button/styles.js');
require('@babel/runtime/helpers/extends');
require('../../../components/LocationCard/index.js');
require('../../../components/PudoCard/index.js');
require('../../../components/ItemCard/index.js');
require('../../../components/SelectItem/index.js');
require('../../../components/ErrorBanner/index.js');
require('../../../components/Footer/index.js');
require('../../../components/StickyFooter/index.js');
require('../../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../../components/Backdrop/index.js');
require('../../../components/LineItemsGroup/index.js');
require('../../../components/Skeleton/ItemCardSkeleton.js');
require('../../../components/Skeleton/LineItemSkeleton.js');
require('../../../components/Skeleton/PudoCardSkeleton.js');
var useLanguage = require('../../../hooks/useLanguage.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const tempLanguageKeys = {
  returnsReasonsTypeTitle: language_en_US["default"].returnsReasonsTypeTitle,
  returnsReasonsTypeReturn: language_en_US["default"].returnsReasonsTypeReturn,
  returnsReasonsTypeExchange: language_en_US["default"].returnsReasonsTypeExchange
};
const ReturnReasonsType = _ref => {
  let {
    allowReturn,
    allowExchange,
    onChange
  } = _ref;
  const {
    returnsReasonsTypeTitle,
    returnsReasonsTypeReturn,
    returnsReasonsTypeExchange
  } = tempLanguageKeys;
  const returnLabel = useLanguage["default"]({
    langKey: 'returnsReasonsTypeReturn',
    defaultString: returnsReasonsTypeReturn
  }).rawValue ?? '';
  const exchangeLabel = useLanguage["default"]({
    langKey: 'returnsReasonsTypeExchange',
    defaultString: returnsReasonsTypeExchange
  }).rawValue ?? '';
  const options = React.useMemo(() => {
    const ret = [];
    if (allowReturn) {
      ret.push({
        label: returnLabel,
        value: 'return'
      });
    }
    if (allowExchange) {
      ret.push({
        label: exchangeLabel,
        value: 'exchange'
      });
    }
    return ret;
  }, [allowReturn, allowExchange, returnLabel, exchangeLabel]);
  const handleChange = e => {
    onChange(e);
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.MediumHeader, null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsReasonsTypeTitle",
    defaultString: returnsReasonsTypeTitle
  })), /*#__PURE__*/React__default["default"].createElement(index$1.SelectList, {
    onChange: handleChange,
    options: options
  }));
};

exports["default"] = ReturnReasonsType;
